import EmailValidator from 'email-validator';

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function emailValido(email) {
  return EmailValidator.validate(email);
}

export const blobToData = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

export const b64toBlob = async (base64) => {
  return await fetch(base64).then(res => res.blob())
}